export const OpenAPI = {
    BASE: '/api/v4',
    VERSION: '4.0.0',
    WITH_CREDENTIALS: false,
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
};
